import React, { useEffect, useState } from 'react';
import {
	NavigationStepperComponentParams,
	NavigationStepperItemType,
} from '../../../../Components/Stepper/NavigationStepper';
import { usePatientTreatmentContext } from './ContextProvider';
import { useAppContext } from '../../../../Services/AppContext';
import WorkplaceCalendar from '../../../../Components/Calendar/WorkplaceCalendar';
import SubTabNavigationStepper from '../../../../Components/Stepper/SubTabNavigationStepper/SubTabNavigationStepper';
import { useAclContext } from '../../../Acl/Components/AclContextProvider';
import PatientTreatmentPageWrapper from './PatientTreatmentPageWrapper';
import EventList from '../../../Events/Components/EventList/EventList';
import { EventListType } from '../../../Events/Enums/eventListType.enum';

const PatientTreatmentCalendar: React.FC = () => {
	const { patientId } = usePatientTreatmentContext();
	const { workplaceId } = useAppContext();
	const [stepParams, setStepParams] = useState({});
	const [steps, setSteps] = useState<NavigationStepperItemType[]>([]);
	const { isAllowed } = useAclContext();

	const handleShowInCalendar = (
		stepKey: string,
		stepParams: { eventId: string },
		params: NavigationStepperComponentParams,
	) => {
		params.setActiveStepPath(stepKey);
		setStepParams(stepParams);
	};

	useEffect(() => {
		const tempSteps: NavigationStepperItemType[] = [];

		if (isAllowed('calendar')) {
			tempSteps.push({
				name: 'patientTreatment.orders.order.title',
				key: 'order',
				component: () => (
					<WorkplaceCalendar
						workplaceId={workplaceId}
						patientId={patientId}
						params={stepParams}
					/>
				),
			});
		}

		tempSteps.push({
			name: 'patientTreatment.orders.patientsOrders.title',
			key: 'patientsOrders',
			component: (params: NavigationStepperComponentParams) => (
				<PatientTreatmentPageWrapper patientId={patientId}>
					<EventList
						key='patientsOrders'
						patientId={patientId}
						handleShowEventInCalendar={(eventId: string) =>
							handleShowInCalendar('order', { eventId }, params)
						}
						type={EventListType.FUTURE}
					/>
				</PatientTreatmentPageWrapper>
			),
		});

		tempSteps.push({
			name: 'patientTreatment.orders.canceledOrders.title',
			key: 'canceledOrders',
			component: (params: NavigationStepperComponentParams) => (
				<PatientTreatmentPageWrapper patientId={patientId}>
					<EventList
						key='canceledOrders'
						patientId={patientId}
						handleShowEventInCalendar={(eventId: string) =>
							handleShowInCalendar('order', { eventId }, params)
						}
						type={EventListType.CANCELED}
						emptyMessage='component.eventList.noCanceledTerms'
					/>
				</PatientTreatmentPageWrapper>
			),
		});

		setSteps(tempSteps);
	}, [stepParams]);

	if (!steps.length) {
		return <></>;
	}

	return (
		<>
			<SubTabNavigationStepper
				steps={steps}
				initialStepPath='order'
				canSkip={true}
			/>
		</>
	);
};

export default PatientTreatmentCalendar;
